module.exports = __webpack_public_path__ + "static/media/avocado_scrub.f9457836.png";